'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RVIcon = function (_React$Component) {
    _inherits(RVIcon, _React$Component);

    function RVIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RVIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RVIcon.__proto__ || Object.getPrototypeOf(RVIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (size, color) {
            return _react2.default.createElement(
                'svg',
                { id: 'RV-insurance', xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 24 24' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: size, height: size, fill: '#fff', opacity: '0' }),
                _react2.default.createElement(
                    'g',
                    { id: 'Group_2650', 'data-name': 'Group 2650', transform: 'translate(0 -0.295)' },
                    _react2.default.createElement('path', { id: 'Path_43633', fill: color, 'data-name': 'Path 43633', d: 'M5.251,19.044A2.248,2.248,0,1,0,7.5,21.292,2.247,2.247,0,0,0,5.251,19.044ZM22.5,2.295H5.08a1.491,1.491,0,0,0-1.343.829l-2.543,4.2a1.482,1.482,0,0,0,.054,1.527,1.515,1.515,0,0,0,1.262.69H4.052a.253.253,0,0,1,.211.115.25.25,0,0,1,.016.24L1.894,15.068a.3.3,0,0,1-.05.072L.4,16.588a1.221,1.221,0,0,0-.4.906v3.8a1.252,1.252,0,0,0,1.25,1.25H1.9a.249.249,0,0,0,.2-.1.252.252,0,0,0,.039-.221A3.2,3.2,0,0,1,2,21.292a3.248,3.248,0,1,1,6.36.93.25.25,0,0,0,.165.311.265.265,0,0,0,.074.011h6.551a.249.249,0,0,0,.2-.1.252.252,0,0,0,.039-.221,3.247,3.247,0,1,1,6.359-.93,3.255,3.255,0,0,1-.136.93.25.25,0,0,0,.165.311.265.265,0,0,0,.074.011H22.5a1.5,1.5,0,0,0,1.5-1.5V3.795a1.5,1.5,0,0,0-1.5-1.5ZM4.288,7.338a.5.5,0,0,1-.069-.451l.667-2a.5.5,0,0,1,.474-.342H10.5a.5.5,0,0,1,.5.5v2a.5.5,0,0,1-.5.5H4.694A.5.5,0,0,1,4.288,7.338ZM11.3,13.352a.692.692,0,0,1-.692.692H5.5a.5.5,0,0,1-.454-.709l1.615-3.5a.5.5,0,0,1,.454-.291H10.6a.692.692,0,0,1,.692.692h0ZM21.749,7.045a.5.5,0,0,1-.5.5H14a.5.5,0,0,1-.5-.5v-2a.5.5,0,0,1,.5-.5h7.25a.5.5,0,0,1,.5.5Zm-3.25,12a2.248,2.248,0,1,0,2.248,2.248h0A2.25,2.25,0,0,0,18.5,19.044Z', transform: 'translate(0 0)' })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RVIcon, [{
        key: 'render',
        value: function render() {
            return this.getIcon(this.props.size || 24, this.props.color);
        }
    }]);

    return RVIcon;
}(_react2.default.Component);

exports.default = RVIcon;